// extracted by mini-css-extract-plugin
export default {"button":"MainButton_button__q8Byc","primary":"MainButton_primary__ufnbT","outline":"MainButton_outline__OYpWs"};